var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoCircle(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "-27.804 -45.373 320 320",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 132.196,
    cy: 114.627,
    r: 160,
    fill: "#3A58D7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M132.196 26C188.085 26.0003 233.391 71.3077 233.392 127.196C233.392 157.509 220.061 184.707 198.945 203.254C187.326 185.23 168.775 172.097 147.06 167.626C163.517 161.572 175.257 145.756 175.257 127.198C175.257 103.416 155.977 84.1367 132.194 84.1367C108.412 84.1367 89.1321 103.416 89.1318 127.198C89.1318 145.349 100.363 160.877 116.254 167.213C94.36 171.107 75.4991 183.767 63.4268 201.434C43.4835 182.951 31 156.532 31 127.196C31.0002 71.3076 76.3075 26 132.196 26Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCircle);
export default __webpack_public_path__ + "static/media/logoCircle.c3b38abc589a617455c410a06574d741.svg";
export { ForwardRef as ReactComponent };